<template>
  <va-card :title="$t('menu.vehicle_bays')">
    <va-button
      small
      outline
      color="dark"
      text-align="left"
      icon="fa fa-cubes"
      class="ma-2"
      :to="{
            name: 'vehicle_bays_draggable',
            params: { loadID: loadID }
      }"
    >{{ $t("menu.show_bays_draggable") }}</va-button>
    <va-data-table :fields="fields" :data="data" :per-page="15">
      <template slot="actions" slot-scope="props">
        <va-button
          small
          inline
          color="success"
          icon="fa fa-table"
          class="ma-0"
          :to="{
            name: 'palletized_products',
            params: { loadID: loadID, bayID: props.rowData.id }
          }"
        >{{ $t("menu.show_palletization") }}</va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import VehicleBaysAPI from '@/services/VehicleBaysAPI'
import LoadPalletizingAPI from '@/services/LoadPalletizingAPI'

export default {
  data () {
    return {
      data: [],
      loadID: '',
    }
  },
  mounted () {
    var self = this
    self.loadID = this.$route.params.loadID
    VehicleBaysAPI.getVehicleBaysByLoadID(self.loadID).then(response => {
      self.data = response.data
    })
  },
  methods: {
    palletizeLoad (loadID) {
      this.loading = true
      LoadPalletizingAPI.palletizeLoad(loadID).then(response => {
        // alert("Carga Paletizada com sucesso!")
        this.loading = false
      })
    },
  },
  computed: {
    fields () {
      return [
        {
          name: 'label',
          title: this.$t('tables.vehicle_bays.label'),
          width: '3%',
        },
        {
          name: 'bay_type.name',
          title: this.$t('tables.vehicle_bays.bay_type'),
          width: '10%',
        },
        {
          name: 'bay_type.width',
          title: this.$t('tables.vehicle_bays.bay_width'),
          width: '10%',
        },
        {
          name: 'bay_type.heigth',
          title: this.$t('tables.vehicle_bays.bay_heigth'),
          width: '10%',
        },
        {
          name: 'bay_type.length',
          title: this.$t('tables.vehicle_bays.bay_length'),
          width: '10%',
        },
        {
          name: 'quantity_layer',
          title: this.$t('tables.vehicle_bays.quantity_layer'),
          width: '10%',
        },
        {
          name: 'quantity_box',
          title: this.$t('tables.vehicle_bays.quantity_box'),
          width: '10%',
        },
        {
          name: 'pallet_height',
          title: this.$t('tables.vehicle_bays.pallet_height'),
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        },
      ]
    },
  },
  // methods: {
  //   getStarMessage (user) {
  //     const actionName = user.starred ? this.$t('tables.unstar') : this.$t('tables.star')
  //     return `${actionName} ${user.fullName}`
  //   },
  //   getStarColor (user) {
  //     return user.starred ? 'primary' : 'gray'
  //   },
  //   star ({ id }) {
  //     const i = this.users.findIndex(user => user.id === id)
  //     this.users[i].starred = !this.users[i].starred
  //   },
  // },
}
</script>

<style lang="scss"></style>
